import Image from 'next/image'
import React from 'react'

import { freeWithdrawalBanner, handMoney } from '@/libs/constants/images-library'

export type TFreeWithdrawalBanner = {
  platformName: string
}

export default function FreeWithdrawalBanner({ platformName }: Readonly<TFreeWithdrawalBanner>) {
  return (
    <div
      data-testid='banner'
      className='flex h-32 w-full items-center justify-center gap-2 rounded-lg bg-white bg-cover bg-center px-3'
      style={{
        backgroundImage: `url(${freeWithdrawalBanner.src})`,
      }}
    >
      <Image src={handMoney.src} alt={handMoney.alt} width='80' height='80' />
      <div className='flex flex-col gap-1'>
        <h1 className='text-base font-semibold'>Free Withdrawal using {platformName}</h1>
        <span className='w-3/4 text-xs font-normal'>
          Enjoy Fast, Secure, and Free Withdrawals with {platformName} Now!
        </span>
      </div>
    </div>
  )
}
